export const BILLING_MANAGE_RENEW_ROUTE = 'manage-renew';
export const BILLING_MANAGE_RENEW_DISABLE_ROUTE = 'disable';
export const BILLING_MANAGE_RENEW_PAYMENT_ROUTE = 'payment';
export const BILLING_PAYMENT_ROUTE = 'payment';
// it contains old query params naming convention, we keep them as now to support it
export const PARAMS = {
  ENCRYPTED_ACCOUNT_ID: 'eaid',
  PROMO_CODE: 'promocode',
  PROMO_CODE_CAMELCASE: 'promoCode',
  PROMO_CODE_SNAKECASE: 'promo_code', // this is the new naming convention of promo code
  PROMO: 'promo',
  EMAIL_SENT_DATE: 'dse',
  EMAIL_SENT_DATE_SNAKECASE: 'email_date', // this is the new naming convention of email sent date
  TAG: 'tag',
  TEST_GROUP: 'test_group',
};

export const PAYWALL_UNKNOWN_URL_ERROR_GROUPING_KEY =
  'billing_unknown_entry_error';
